import { computed } from 'vue';

//
var script = {
  props: {
    align: {
      type: String,
      default: 'left',
      validator: value => ['left', 'center', 'right'].includes(value)
    }
  },
  setup(props) {
    const classes = computed(() => {
      return {
        'form-actions--center': props.align === 'center',
        'form-actions--right': props.align === 'right'
      };
    });
    return {
      classes
    };
  }
};
export { script as default };